var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClicknmeet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_clicknmeet_svg__cls-2{fill:#004aad}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 1a15.79 15.79 0 1015.79 15.79A15.79 15.79 0 0019.94 1zm.16 4a4.78 4.78 0 014.69 4.87 4.69 4.69 0 11-9.38 0A4.78 4.78 0 0120.1 5zm9.71 21.83s0 1.14-1.49 1.14h-2.61v-5.72h-1.44v5.67h-8.68v-5.67h-1.43v5.67h-2.24c-1.49 0-1.49-1.14-1.49-1.14v-3.39s1.49-7.55 7.08-7.93l1.88-.12c-.16 0-.08-.06.73 0s.88 0 .73 0l1.88.12c5.59.38 7.08 7.93 7.08 7.93z",
    fill: "#fff",
    stroke: "#c01774",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_clicknmeet_svg__cls-2",
    d: "M34.92 41.75l-5.07-5.07c-.48-.48-1-.32-1.59.32l-1 1c-1.27 1.26-1.9 0-1.9 0s-5.55-14.11-5.71-14.9-.15-1.42.95-.95 14.27 6.66 14.27 6.66 1 .61.31 1.26l-1.11 1.11c-1.42 1.43-.79 1.75-.79 1.75S38.24 37.15 39 38a1.09 1.09 0 010 1.58l-2.22 2.22s-1.07.74-1.86-.05zM36.04 23.83h.84v2.09h-.84zM39.554 25.576l.507.669-1.666 1.262-.507-.669zM40.85 29.06v.84h-2.09v-.84zM22.48 38.31v.84h-2.09v-.84zM23.074 40.532l.55.635-1.582 1.367-.55-.636zM24.83 41.91h.84V44h-.84z"
  })));
}

export default SvgIconClicknmeet;